export default __webpack_public_path__ + "static/media/mockup-movies.bda9edfc.png";